import React, { useMemo } from 'react';
import { usePathname } from '@/routing/hooks/utils';
import { useLocalization } from '@/localization';
import { NavigationDrawerSublinkItem } from './drawer-sublink-item.component';
import { TitleBadge } from '@/search-for-retail/generic/title-badge/title-badge.component';
import { PageIdentifier } from '@/constants';
import { getPath } from '@/navigation/drawer/lib';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
export const DrawerLink = ({ route, label, badgeLabel, onClick, disabled, level, }) => {
    var _a;
    const { formatMessage: t } = useLocalization();
    const activeRoute = usePathname();
    const activeCollection = useSessionCollectionName();
    const activeArea = useSessionAreaName();
    const path = getPath(route, activeCollection, activeArea);
    const arePathsEqual = activeRoute === path;
    // Temporary fix to address breaking change that impacted enrich.
    // For all dynamic routes (enrich included), 'activeArea' was required in order to set active to 'true'.
    // S4R-3714 should address the underlying issue.
    const active = route.name === PageIdentifier.ANALYTICS ? activeArea && arePathsEqual : arePathsEqual;
    const textLabel = label !== null && label !== void 0 ? label : route.label;
    // Use customLabel if provided, otherwise use localized text
    const displayText = (_a = route.customLabel) !== null && _a !== void 0 ? _a : t({ key: textLabel });
    const badge = useMemo(() => (badgeLabel
        ? <TitleBadge label={t({ key: badgeLabel })} size="small"/>
        : undefined), [badgeLabel, t]);
    const handleClick = () => {
        const isActivePageClicked = arePathsEqual && !window.location.search;
        onClick(isActivePageClicked, path);
    };
    return (<NavigationDrawerSublinkItem active={active} text={displayText} onClick={handleClick} badge={badge} disabled={disabled} level={level}/>);
};
export default DrawerLink;
